var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-container',{staticClass:"text-center pa-1 text-body-2"},[_vm._v(" BaconHash © "+_vm._s(_vm.year)+" - "),_c('a',{attrs:{"href":"https://pcaro.es"}},[_vm._v("Pablo Caro")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }